import type { CounterSlice, CounterState, SliceCreator } from "../types";

export const counterInitialState = (): CounterState => ({
  counter: {
    value: 0
  }
});

export const createCounterSlice: SliceCreator<CounterSlice> = (set) => ({
  ...counterInitialState(),
  increment: () =>
    set(
      (state) => ({
        counter: { value: state.counter.value + 1 }
      }),
      false,
      "counter/increment"
    ),
  decrement: () =>
    set(
      (state) => ({
        counter: { value: state.counter.value - 1 }
      }),
      false,
      "counter/decrement"
    ),
  setCounter: (value: number) =>
    set(
      () => ({
        counter: { value }
      }),
      false,
      "counter/set"
    )
});

